export default __webpack_public_path__ + "static/media/Apiario.21b892ac.png";